<template lang="html">
    <div>
        <!-- Top bar-->
        <result-header/>
        <!-- Begin Page Content -->
        <components v-bind:is="Content" v-on:change-view="goPage" :properties="properties" />
    </div>
</template>

<script>
    import Header from '@/views/Common/Header.vue'
	import List from '@/views/Common/List.vue'
	import Create from '@/views/Result/Detail.vue'
	
    export default {
        name: 'Result',
        components: 
        {
            'result-header': Header,
			'result-content': List,
            'result-create': Create
        },
        created () {
            this.$axios.defaults.headers.common['x-access-token'] = this.$store.getters.getAccessToken;
            this.$axios.defaults.headers.common['x-refresh-token'] = this.$store.getters.getRefreshToken;
            
        },
        mounted(){
			//화면 새로고침시 기존 화면 불러오기

			if(this.$route.params.mid){
                this.goPage({'mid':this.$route.params.mid, 'type':this.$route.params.type, 'task':this.$route.params.task});
			}else{
                this.goPage({'mid':sessionStorage.mid, 'type':sessionStorage.type, 'task':sessionStorage.task});
			}
        },
        data () {
            return {
                Content: '',
                properties:[],
            }
        },
        methods: {
            goPage(data){
                this.Content = 'result-content';
                this.properties = data;
                sessionStorage.removeItem('type');
                sessionStorage.removeItem('mid');
                sessionStorage.removeItem('task');
                sessionStorage.setItem('type', data.type);
                sessionStorage.setItem('mid',data.mid);
                sessionStorage.setItem('task',data.task);
            },
            trigger (data) {
                console.log(data)
                this.goPage(data);
            }
        },
        
    }
</script>



// WEBPACK FOOTER //
// src/views/Result/Result.vue